$mol_speck $mol_view
	minimal_width 12
	attr *
		^
		mol_theme <= theme \$mol_theme_accent
	style *
		^
		minHeight \1em
	sub /
		<= value null
